module.exports = __webpack_public_path__ + "spinner-67bf5b7c00801ceed5f8.svg";